// 관리자 로그인 / 관리자 페이지 제목
const admin = {
  ko: {
    gate: {
      eyebrow: 'ADMIN ACCESS',
      defaultTitle: '관리자 전용',
      desc1: '참가 목록, 회원 관리, 토너먼트 관리는 관리자만 이용할 수 있습니다.',
      desc2: '관리자 계정으로 로그인해 주세요.',
      email: '관리자 이메일',
      password: '비밀번호',
      passwordPlaceholder: '비밀번호 입력',
      login: '로그인',
      loggingIn: '로그인 중...',
      required: '이메일과 비밀번호를 입력해 주세요.',
      adminOnly: '관리자 계정만 이용할 수 있습니다.',
      failed: '로그인에 실패했습니다.',
      expired: '로그인이 만료되었습니다. 다시 로그인해 주세요.',
    },
    titles: {
      participants: '참가 목록 (관리자)',
      tournament: '토너먼트 관리 (관리자)',
      members: '회원 관리 (관리자)',
    },
  },
  en: {
    gate: {
      eyebrow: 'ADMIN ACCESS',
      defaultTitle: 'Admins only',
      desc1: 'Participants, members and tournament management are available to admins only.',
      desc2: 'Please sign in with an admin account.',
      email: 'Admin email',
      password: 'Password',
      passwordPlaceholder: 'Enter password',
      login: 'Sign in',
      loggingIn: 'Signing in...',
      required: 'Please enter your email and password.',
      adminOnly: 'Only admin accounts can sign in here.',
      failed: 'Sign-in failed.',
      expired: 'Your session has expired. Please sign in again.',
    },
    titles: {
      participants: 'Participants (Admin)',
      tournament: 'Manage Tournament (Admin)',
      members: 'Members (Admin)',
    },
  },
};

export default admin;
